import type { ComponentType } from 'react';

export class ComponentsRegistry {
  public components: Map<string, ComponentType> = new Map([]);

  public getComponent(componentName: string) {
    const component = this.components.get(componentName);
    if (!component) {
      throw new Error(`Component ${componentName} not found`);
    }
    return component;
  }

  public registerComponent(componentName: string, component: ComponentType) {
    if (this.components.has(componentName)) {
      this.unregisterComponent(componentName);
    }
    this.components.set(componentName, component);
  }

  public unregisterComponent(componentName: string) {
    this.components.delete(componentName);
  }
}

export const componentsRegistry = new ComponentsRegistry();
